import { combineReducers } from 'redux'
import settings from './settings'
import general from './general'
import euer from './euer'

export default combineReducers({
  general,
  euer,
  settings,
})
